import { jsx as o, jsxs as k } from "react/jsx-runtime";
import { forwardRef as z } from "react";
import D from "clsx";
import g from "../builders-icons/dist/systems/arrow-right.js";
import { useTracking as I, getText as R } from "../utils.js";
import { Loader as V } from "../loader/loader.js";
import t from "./button.module.less.js";
const m = /* @__PURE__ */ o(V, { className: t.loader, size: "sm", variant: "ellipsis" }), K = z(function({
  arrow: u,
  children: h,
  className: x,
  disabled: v = !1,
  flexible: y = !1,
  icon: a,
  iconPosition: p = "left",
  loading: i = !1,
  onClick: n,
  as: j,
  size: N = "md",
  variant: T = "primary",
  tracking: O = !0,
  ...e
}, w) {
  const f = j || (e.href ? "a" : "button"), l = T.split("-")[0], b = l === "action", d = v || i, A = D(
    t.button,
    t[l],
    t[N],
    y && t.flexible,
    x
  ), B = I(O), L = (c) => {
    if (d)
      return c.preventDefault();
    B({
      eventCategory: `button_${l}`,
      eventAction: "click",
      eventLabel: R(c.currentTarget)
    }), n == null || n(c);
  };
  let s = null, r = null;
  return u === "left" ? s = /* @__PURE__ */ o(g, { className: t.arrow }) : (u || l === "action" && !a) && (r = /* @__PURE__ */ o(g, { className: t.arrow })), a && p === "left" && (s = a), a && p === "right" && (r = a), b && i && (s ? s = m : r && (r = m)), e.href || Object.assign(e, { href: void 0 }), f === "button" && Object.assign(e, { type: e.type || f }), d && Object.assign(e, {
    [f === "button" ? "disabled" : "aria-disabled"]: !0,
    "aria-busy": i || void 0,
    tabIndex: -1
  }), /* @__PURE__ */ k(f, { ...e, className: A, onClick: L, ref: w, children: [
    i && !b && m,
    s,
    /* @__PURE__ */ o("span", { className: t.content, children: h }),
    r
  ] });
});
export {
  K as Button
};
//# sourceMappingURL=button.js.map
